// Menú desplegable de móvil: solo añade cerrar al tocar fuera y con Escape.
//
// Abrir y cerrar ya lo hace el <details> nativo. Si este archivo no llega a
// cargar, el menú sigue funcionando entero: se abre, se navega y se cierra
// pulsando otra vez. Lo único que se pierde es la comodidad.

const menu = document.querySelector('[data-menu]');

if (menu) {
  // pointerdown y NO click: si el dedo o el ratón se mueve un píxel entre
  // pulsar y soltar, el click no llega a dispararse y el menú se queda abierto.
  document.addEventListener('pointerdown', (ev) => {
    if (menu.open && !menu.contains(ev.target)) menu.open = false;
  });

  document.addEventListener('keydown', (ev) => {
    if (ev.key === 'Escape' && menu.open) {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    }
  });

  // Al elegir cualquier cosa del panel se cierra solo: un destino o el propio
  // carrito. Con el carrito hace especial falta, porque abre el cajón lateral
  // y el menú se quedaria abierto detrás.
  menu.addEventListener('click', (ev) => {
    if (ev.target.closest('a, button')) menu.open = false;
  });
}
